<template>
    <vs-sidebar
        v-model="isActive"
        class="items-no-padding"
        parent="#expenses-app"
        v-on="$listeners"
        v-bind="$attrs"
        ref="sidebar"
    >
        <vx-main-sidebar :menu-routes="menuRoutes" />
    </vs-sidebar>
</template>

<script>
export default {
    name: 'maarima-sidemenu',
    props: {
        value: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        isActive: {
            get() {
                return this.value
            },
            set(v) {
                this.$emit('input', v)
            }
        },
        menuRoutes() {
            let response = {
                'Overview': ['mm-dashboard'],
                'Requests': ['mm-requests'],
                'Service Tasks': ['mm-tasks']
            }
            if (this.userHasRole(['ADMINISTRATOR', 'SuperUser'])) {
                response['Reports'] = ['mm-export'] // ['mm-awaiting-claim', 'mm-claims']
            }
            return response
        }
    }
}
</script>
